<template style="background: #f5f5f5;">
    <v-container fluid>
        <v-layout style="flex-direction: column;">
            <v-row>
                <v-col>
                    <v-flex>
                         <v-data-table
                            :headers="headers"
                            :items="CotizacionesDatos"
                            class="elevation-1"
                            :search="search"
                            :loading="loadigtable"
                            loading-text="Loading... Please wait"
                            :footer-props="{
                                showFirstLastPage: true,
                                firstIcon: 'skip_previous',
                                lastIcon: 'skip_next',
                                prevIcon: 'keyboard_arrow_left',
                                nextIcon: 'keyboard_arrow_right'
                            }"
                        >
                            <template v-slot:top>
                                <v-toolbar flat color="white">
                                    <v-toolbar-title>Cotizaciones</v-toolbar-title>
                                    <v-divider
                                        class="mx-4"
                                        inset
                                        vertical
                                    ></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                                    <v-spacer></v-spacer> 
                                    <v-select v-if="$store.state.usuario.rol == 'ComercialAdmin' || $store.state.usuario.rol == 'Administrador' || $store.state.usuario.rol == 'Marketing'|| $store.state.usuario.rol == 'Finanzas' " label="Ejecutivo" v-model="idejecutivo" dense outlined :items="ejecutivos" v-on:change="buscarejecutivo()"></v-select>
                                </v-toolbar>
                            </template>
                            <template v-slot:[`item.fechsend`]="{ item }">
                                <template v-if="item.fechsend === '01 enero 1753'">
                                    <span>-</span>
                                </template>
                                <template v-else>
                                    <span>{{item.fechsend}}</span>
                                </template>
                            </template>
                            <template v-slot:[`item.opciones`]="{ item }">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">                    
                                        <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            @click="editItemCot(item)"
                                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"
                                            color="#3d5170"
                                            >
                                            edit
                                        </v-icon>
                                    </template>
                                    <span>edit</span>
                                </v-tooltip>
                                <v-tooltip top v-if="item.enviada == true">
                                    <template v-slot:activator="{ on, attrs }">                    
                                        <v-icon
                                            v-if="item.actividad_completada == true"
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            @click="AgregarComentarios(item)"
                                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;background: rgb(0 194 255);color: white;"                                            
                                            >
                                            add
                                        </v-icon>
                                        <v-icon
                                            v-else
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            @click="AgregarComentarios(item)"
                                            style="padding: 4px;border: 1px solid #bdbdbdb0;border-radius: 3px;margin-left:3px;"                                            
                                            >
                                            add
                                        </v-icon>
                                    </template>
                                    <span>Comentarios</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:[`item.asignada`]="{ item }">
                                <template v-if="item.asignada === true">
                                    <v-icon
                                    small
                                    class="mr-2"
                                    style="color: #4CAF50;font-weight: 600;"
                                    >
                                    done
                                    </v-icon>  
                                </template>
                                <template v-else>
                                    <v-icon
                                    small
                                    class="mr-2"
                                    style="color: red;font-weight: 600;"
                                    >
                                    clear
                                    </v-icon> 
                                </template>
                            </template>  
                            <template v-slot:no-data>
                            <v-btn
                                color="primary"
                                @click="Listar()"
                            >
                                Reset
                            </v-btn>
                            </template>
                        </v-data-table>
                    </v-flex>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-dialog
                    max-width="600"
                    v-model="dialogne"
                    >
                        <template v-slot:default="dialogne">
                        <v-card>
                            <v-toolbar
                            color="primary"
                            dark
                            >Negotiation {{ncotizacionview}}</v-toolbar>
                            <v-card-text>
                                <br>
                                <v-row>
                                     <v-col md="4" lg="4" xl="4">
                                         <v-btn-toggle
                                            v-model="pickup"
                                            tile
                                            color="blue"
                                            style="border: 1px solid;margin-bottom: 12px;margin-right: 8px;"
                                            group    
                                            dense                                 
                                            >
                                                <v-btn  @click="Credityes" value="credit" >
                                                    Pick Up
                                                </v-btn>                                    
                                            </v-btn-toggle>
                                     </v-col>
                                     <v-col md="4" lg="4" xl="4">
                                         <v-btn-toggle
                                            v-model="principal"
                                            tile
                                            color="blue"
                                            style="border: 1px solid;margin-bottom: 12px;margin-right: 8px;"
                                            group    
                                            dense                                 
                                            >
                                                <v-btn  @click="Credityes" value="credit" >
                                                    Principal Rate
                                                </v-btn>                                    
                                            </v-btn-toggle>
                                     </v-col>
                                     <v-col md="4" lg="4" xl="4">
                                         <v-btn-toggle
                                            v-model="delivery"
                                            tile
                                            color="blue"
                                            style="border: 1px solid;margin-bottom: 12px;margin-right: 8px;"
                                            group    
                                            dense                                 
                                            >
                                                <v-btn  @click="Credityes" value="credit" >
                                                    Delivery
                                                </v-btn>                                    
                                            </v-btn-toggle>
                                     </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field label="Days Origin" outlined dense></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field label="Days Destination" outlined dense></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field label="$Rate" outlined dense></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-textarea label="Remarks" outlined dense></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                            <v-card-actions class="justify-end">
                                <v-btn
                                color="error"
                                text
                                @click="dialogne.value = false"
                            >Cancel</v-btn>
                            <v-btn
                                text
                                @click="dialogne.value = false"
                            >Send</v-btn>
                            </v-card-actions>
                        </v-card>
                        </template>
                    </v-dialog>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-dialog
                    max-width="600"
                    v-model="dialograte"
                    >
                    <v-card>
                         <v-toolbar
                            >Negotiation {{ncotizacionview}}
                            <v-spacer></v-spacer>
                            <v-btn color="primary">Print</v-btn>    
                        </v-toolbar>
                        <v-card-text><br>
                            <table style="width: 100%;text-align: center;width: 100%;color: black;font-weight: 500;">
                                <tr>
                                    <td><span>Principal Rate</span></td>
                                </tr>
                                <tr>
                                    <td style="border-bottom: 1px solid #bdbdbd;">Quantity</td>
                                    <td style="border-bottom: 1px solid #bdbdbd;">size</td>
                                    <td style="border-bottom: 1px solid #bdbdbd;">Type</td>
                                    <td style="border-bottom: 1px solid #bdbdbd;">Rate</td>
                                    <td style="border-bottom: 1px solid #bdbdbd;">Vigencia</td>
                                </tr>
                                <tr>
                                        <td style="border-bottom: 1px solid #bdbdbd;">2</td>
                                        <td style="border-bottom: 1px solid #bdbdbd;">20'</td>
                                        <td style="border-bottom: 1px solid #bdbdbd;">DRY CARGO	</td>
                                        <td style="border-bottom: 1px solid #bdbdbd;">400 / per container</td> 
                                        <td style="border-bottom: 1px solid #bdbdbd;">27 enero 2021</td> 
                                </tr>
                                <tr>
                                    <td style="    text-align: initial;" colspan="5">
                                        Additiona Charges
                                    </td>
                                </tr>
                                <tr>
                                    <td style="    text-align: initial;" colspan="5">Tarifas Adicionales ------------------</td>
                                </tr>
                                <tr>
                                    <td style="    text-align: initial;" colspan="5">
                                        Observations
                                    </td>
                                </tr>
                                <tr>
                                    <td style="    text-align: initial;" colspan="5">Comentarios por parte de pricing ------------------</td>
                                </tr>
                            </table>
                        </v-card-text>
                    </v-card>
                    </v-dialog>
                </v-col>
            </v-row><br>
            <v-card v-if="InfoCot== true">
                <v-card-text>
                    <div style="margin-bottom: 20px;">
                                    <header style="width: 100%">
                                        <table style="width: 100%;">
                                            <tr>
                                                <td>
                                                    <img style="width: 280px;" src="../assets/logo1.png" alt="">
                                                </td>
                                                <td style="align-items: end;
                                                display: flex;
                                                justify-content: end;
                                                flex-direction: column;">
                                                    <v-switch v-model="asignada" v-on:change="Verificar()"></v-switch>
                                                    <span v-if="asignada == true" style="color: #ffffff;font-size: 1.2rem;font-weight: 600;border: 1px solid;padding: 5px;background: #079d07;text-align: end;">Cotizacion Asignada</span>
                                                    <span v-else style="color: #ffffff;font-size: 1.2rem;font-weight: 600;border: 1px solid;padding: 5px;background: #fc0303;text-align: end;" >Cotizacion no Asignada</span>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2" style="text-align: end;font-size: 14px;font-weight: 600;">CDMX, a {{fechaHoy}}</td>
                                            </tr>
                                        </table>
                                    </header>
                                    <section>
                                        <table style="width: 100%;">
                                            <tr>
                                                <td style="font-size: 14px;font-weight: 600;">Folio de Cotización: <span style="color:black;">{{ncotizacion}}</span></td>
                                            </tr>
                                            <tr>
                                                <td style="font-size: 14px;font-weight: 600;">Cliente:{{ncustumre}}</td>
                                            </tr>
                                            <tr>
                                                <td style="font-size: 14px;font-weight: 600;">Atención:</td>
                                                <td style="display: flex;">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn
                                                            color="primary"
                                                            dark
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click="viewContacto()"
                                                            icon
                                                            >
                                                            <v-icon style="color: #455A64;">person_add</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Agregar Contacto</span>
                                                    </v-tooltip>
                                                    <v-combobox
                                                        v-model="contactoscot"
                                                        :items="contactospresente"
                                                        :search-input.sync="searcho"
                                                        hide-selected                                          
                                                        label="Contactos"
                                                        multiple
                                                        persistent-hint
                                                        small-chips
                                                        style="margin-left: 8px;"
                                                        outlined
                                                        dense
                                                    >
                                                        <template v-slot:no-data>
                                                            <v-list-item>
                                                            <v-list-item-content>
                                                                <v-list-item-title>
                                                                No se encuentran mas contactos"<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">

                                                    <div id="app" style="border: 1px solid;width: 99%;">
                                                        <ckeditor style="color:black;" :editor="editor" @ready="onReady" v-model="cuerpo"></ckeditor>
                                                    </div><br>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Modalidad: </span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="modalidadtext2"
                                                    solo
                                                    dense
                                                    ></v-text-field></td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Movimiento:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="Movimientotext"
                                                    solo
                                                    dense
                                                    ></v-text-field></td>
                                            </tr>
                                             <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Producto:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="productotext"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Origen:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="origentext"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Destino:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="destinotext"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Servicio:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="serviciotext"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Via:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="viatext"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">Transbordo:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="transbordo"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="display: flex;align-items: baseline;font-size: 14px;font-weight: 600;"><span style="width: 80px;">T.T.:</span>
                                                    <v-text-field
                                                    style="margin-left: 8px;"
                                                    v-model="tttext"
                                                    solo
                                                    dense
                                                    ></v-text-field>
                                                </td>
                                            </tr>
                                                <tr>
                                                    <td colspan="4">
                                                        <v-switch
                                                            
                                                        v-model="incseguromercancia"
                                                        :label="`${incseguromercancia} incluye seguro.`"
                                                        color="primary"
                                                        false-value="NO"
                                                        true-value="SI"
                                                        style="max-width: 180px;"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4">
                                                        <v-switch    
                                                        v-model="contizacioningles"
                                                        :label="`${contizacioningles} `"
                                                        color="primary"
                                                        false-value="ESPAÑOL"
                                                        true-value="INGLES"
                                                        style="max-width: 180px;"
                                                        @click="cargarremarks"
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4">
                                                        <table style="border: 1px solid #CFD8DC;padding: 8px;border-radius: 8px;">
                                                            <tr>
                                                                <td><v-text-field label="Concepto" v-model="chargeconcepto" outlined dense></v-text-field></td>
                                                                <td><v-select item-text="text" return-object item-value="value" label="Costo por" v-on:change="activarcantidad" v-model="chargecostopor" dense outlined style="margin-left: 5px;" :items="preciocostopor"></v-select></td>
                                                                <td><v-text-field type="number" label="Cantidad" :disabled="activarc" v-model="chargecantidad" outlined dense></v-text-field></td>
                                                                <td><v-text-field type="number" label="Costo Unitario" v-model="chargecostounitario" outlined dense></v-text-field></td>
                                                            </tr>
                                                            <tr style="display: flex;">
                                                                <td><v-select item-text="text" return-object item-value="value" label="moneda" v-model="chargemoneda" dense outlined style="margin-left: 5px;" :items="monedas"></v-select></td>
                                                                <td style="margin-left:3px;">
                                                                    <v-checkbox style="margin-top: 0px;"
                                                                    v-model="chargeiva"
                                                                    label="Iva"
                                                                    color="info"
                                                                    value:1
                                                                    hide-details
                                                                    dense
                                                                    ></v-checkbox>
                                                                </td>
                                                                <td><v-btn color="primary" style="margin-left: 5px;" @click="agregarcosto">Add</v-btn></td>
                                                            </tr>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <v-checkbox
                                                            v-model="MostrarTotal"
                                                            value:1                                                                        
                                                            label="Mostrar Total"
                                                            style="width:150px;"
                                                            hide-details
                                                            dense
                                                        ></v-checkbox>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4">
                                                        <v-simple-table style="margin-bottom: 12px;">
                                                            <thead>
                                                                <tr>
                                                                    <th>OPCIONES</th>
                                                                    <th>CONCEPTO</th>
                                                                    <th>COSTO POR:</th>
                                                                    <th>CANTIDAD</th>
                                                                    <th>COSTO UNITARIO</th>
                                                                    <th>MONEDA</th>
                                                                    <th>SUB TOTAL</th>
                                                                    <th>IVA</th>
                                                                    <th>TOTAL</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <template v-for="det in costos">
                                                                    <tr v-if="det.activo === true">
                                                                        <td style="text-align: center;">
                                                                            <v-tooltip top>
                                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                                    <v-icon
                                                                                        v-bind="attrs"
                                                                                        v-on="on"
                                                                                        small
                                                                                        class="mr-2"
                                                                                        @click="editItemcostos(det)"
                                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                        color="#3d5170"
                                                                                        >
                                                                                        edit
                                                                                    </v-icon>
                                                                                </template>
                                                                                <span>Edit</span>
                                                                            </v-tooltip>
                                                                            <v-tooltip top>
                                                                                <template v-slot:activator="{ on, attrs }">                    
                                                                                    <v-icon
                                                                                        v-bind="attrs"
                                                                                        v-on="on"
                                                                                        small
                                                                                        class="mr-2"
                                                                                        @click="deleteICosto(det)"
                                                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                        color="#3d5170"
                                                                                        >
                                                                                        delete
                                                                                    </v-icon>
                                                                                </template>
                                                                                <span>Delete</span>
                                                                            </v-tooltip>
                                                                        </td>
                                                                        <td style="text-align: center;">{{det.concepto}}</td>
                                                                        <td style="text-align: center;">{{det.costopor}}</td>
                                                                        <td style="text-align: center;">{{det.cantidad}}</td>
                                                                        <td style="text-align: center;">{{det.ncostounitario}}</td>
                                                                        <td style="text-align: center;">{{det.moneda}}</td>
                                                                        <td style="text-align: center;">{{det.nsubtotal}}</td>
                                                                        <td style="text-align: center;">{{det.nniva}}</td>
                                                                        <td style="text-align: center;">{{det.ntotal}}</td>
                                                                    </tr>
                                                                </template>
                                                                <tr v-if="activousd == true && MostrarTotal == 1">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td style="text-align: center;">Total USD</td>
                                                                    <td style="text-align: center;">{{nsubtotalusd}}</td>
                                                                    <td style="text-align: center;">{{nivausd}}</td>
                                                                    <td style="text-align: center;">{{ntotalusd}}</td>
                                                                </tr>
                                                                <tr v-if="activomxn == true && MostrarTotal == 1">
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td></td>
                                                                    <td style="text-align: center;">Total MXN</td>
                                                                    <td style="text-align: center;">{{nsubtotalmxn}}</td>
                                                                    <td style="text-align: center;">{{nivamxn}}</td>
                                                                    <td style="text-align: center;">{{ntotalmxn}}</td>
                                                                </tr>
                                                            </tbody>
                                                        </v-simple-table>
                                                    </td>
                                                </tr>
                                                <td style="display: flex;align-items: center;">
                                                    <span>Vigencia:</span>
                                                    <!--<v-menu
                                                            v-model="menu2"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="290px"
                                                            disabled
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="dateval"
                                                                prepend-icon="mdi-calendar"
                                                                readonly
                                                                v-bind="attrs"
                                                                v-on="on"
                                                            ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                            v-model="dateval"
                                                            @input="menu2 = false"
                                                            ></v-date-picker>
                                                        </v-menu>-->
                                                    <v-menu
                                                        v-model="menu2"
                                                        :close-on-content-click="false"
                                                        max-width="290"
                                                        dense
                                                        >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                            :value="computedDateFormatrecei"
                                                            clearable
                                                            readonly
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click:clear="dateval = null"
                                                            dense
                                                            :rules="[v => !!v || 'Date pick up is required']"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            v-model="dateval"
                                                            @change="menu2 = false"
                                                            :min="nowDate"
                                                            :max="vigenciatarifa"
                                                        ></v-date-picker>
                                                    </v-menu> 
                                                </td>
                                            <tr>
                                                <td colspan="2">
                                                    <tr style="display: flex;">
                                                        <td>
                                                            <v-text-field placeholder="Remarks" solo dense v-model="remarksc"></v-text-field>
                                                        </td>
                                                        <td>
                                                            <v-select
                                                            item-text="text" return-object item-value="value"
                                                            :items="RemarksCotizacion"
                                                            placeholder="List Remarks"
                                                            v-model="remarklist"
                                                            solo
                                                            dense
                                                            v-on:change="mostrarfree"
                                                            style="margin-left: 8px;"
                                                            ></v-select>
                                                        </td>
                                                        <td>
                                                            <v-btn @click="agregarremarks()" style="margin-left: 8px;" color="primary">Add</v-btn>
                                                        </td>
                                                    </tr>
                                                </td>
                                            </tr>
                                            <tr v-if="remarksview == true">
                                                <td colspan="2">
                                                    <v-simple-table v-model="remk" style="margin-bottom: 12px;">
                                                        <thead>
                                                            <tr>
                                                                <th>Remarks</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="det in remarkstextc" :key="det.num">
                                                                <template v-if="det.activo == true">
                                                                    <td style="text-align: center;">
                                                                        <v-tooltip top>
                                                                            <template v-slot:activator="{ on, attrs }">                    
                                                                                <v-icon
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    small
                                                                                    class="mr-2"
                                                                                    @click="editRemarks(det)"
                                                                                    style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                    color="#3d5170"
                                                                                    >
                                                                                    edit
                                                                                </v-icon>
                                                                            </template>
                                                                            <span>Edit</span>
                                                                        </v-tooltip>
                                                                        <v-tooltip top>
                                                                            <template v-slot:activator="{ on, attrs }">                    
                                                                                <v-icon
                                                                                    v-bind="attrs"
                                                                                    v-on="on"
                                                                                    small
                                                                                    class="mr-2"
                                                                                    @click="deleteRemarks(det)"
                                                                                    style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                                    color="#3d5170"
                                                                                    >
                                                                                    delete
                                                                                </v-icon>
                                                                            </template>
                                                                            <span>Delete</span>
                                                                        </v-tooltip>
                                                                    </td>
                                                                    <td>{{det.text}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </v-simple-table>
                                                </td>
                                            </tr>
                                            <tr v-if="!idejecutivo || idejecutivo == idej">
                                                <v-btn
                                                    color="primary"
                                                    @click="GuardarCotizacion()"
                                                >Guardar Cotizacion</v-btn>
                                                <v-btn style="margin-left: 8px;"
                                                    color="primary"
                                                    @click="crearCotizacion()"
                                                >Generar Cotizacion</v-btn>
                                                <router-link  style="font-weight: 500;padding:10px;background:rgb(21 131 218);color: white;border-radius: 4px;text-decoration: none;margin-left: 8px;box-shadow: rgb(0 0 0 / 16%) 0px 3px 5px 1px;" :to="{ name: 'Bs', params: { idscotizacion: idscotizacion,ncotizacion: ncotizacion }}">Generar BS</router-link>
                                            </tr>
                                        </table>
                                    </section>
                                </div>
                            <v-dialog
                                    v-model="dialoview"
                                    scrollable
                                    width="80%"
                                >
                                <v-card >
                                    <v-card-title style="color: #2f73a8;font-weight: 600;justify-content: space-between;">Cotización #{{ncotizacion}}  <span> Tarifa# {{ Ntarifa }}</span></v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text v-if="ver===true">
                                        <div id="viewer">
                                            <PDFJSViewer style="width: 100%;" :path="`${path}`" :fileName="`${namecot}`"/>
                                        </div>
                                    </v-card-text>
                                    <v-card-actions style="justify-content: flex-end;" v-if="ver===true">
                                        <v-btn color="primary" @click="ver=false,enviar=true">Continuar</v-btn>
                                        <v-btn color="error" style="margin-left:8px;" @click="dialoview=false">Cancelar</v-btn>
                                    </v-card-actions>
                                    <v-card-text style="padding: 0 20px;" v-model="cartap" v-if="enviar===true">
                                        <v-spacer></v-spacer>
                                        <v-row style="padding: 0;height: 80px;">
                                            <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;align-items: center;">
                                            <span>Para:</span>
                                            </v-col>
                                            <v-col sm="10" md="10" lg="10" xl="10" style="align-content: center;padding: 0;text-align: center;display: flex;align-items: center;margin-top: 20px;" >
                                            <v-combobox
                                                    v-model="contactoscp"
                                                    :items="contactosprospecto"
                                                    :search-input.sync="searcho"
                                                    hide-selected                                          
                                                    label="Contactos"
                                                    multiple
                                                    persistent-hint
                                                    small-chips
                                                    style="margin-left: 8px;"
                                                    outlined
                                                    dense
                                                >
                                                    <template v-slot:no-data>
                                                        <v-list-item>
                                                        <v-list-item-content>
                                                            <v-list-item-title>
                                                            No se encuentran mas contactos"<strong>{{ searcho }}</strong>". presiona <kbd>enter</kbd> para crear uno nuevo
                                                            </v-list-item-title>
                                                        </v-list-item-content>
                                                        </v-list-item>
                                                    </template>
                                                </v-combobox>
                                            </v-col>
                                        </v-row>
                                        <v-row style="padding: 0;height: 50px;">
                                            <v-col sm="2" md="2" lg="2" xl="2" style="flex-flow: row-reverse;display: flex;padding: 10px;">
                                            <span>Asunto:</span>
                                            </v-col>
                                            <v-col sm="10" md="10" lg="10" xl="10" style="padding: 10px;color: black;align-content: center;padding: 0;display: flex;align-items: center;">
                                                <v-text-field v-model="cpasunto" label="asunto" single-line outlined dense></v-text-field>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <div id="app" style="border: 1px solid;">
                                                    <ckeditor style="color:black;" :editor="editor" @ready="onReady" v-model="editorcp"></ckeditor>
                                                </div>
                                            </v-col>
                                        </v-row><br>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions style="justify-content: flex-end;" v-if="enviar===true">
                                        <v-btn style="margin-top: 8px" text @click="ver=true,enviar=false">Cancelar</v-btn>
                                        <v-btn style="margin-top: 8px" color="primary" @click="enviarcorreocp()">Enviar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                            <v-dialog
                                v-model="dialodload"
                                hide-overlay
                                persistent
                                width="300"
                            >
                                <v-card 
                                color="primary"
                                dark
                                >
                                    <v-card-text><br>
                                        Please stand by
                                    <v-progress-linear
                                        indeterminate
                                        color="white"
                                        class="mb-0"
                                    ></v-progress-linear>                    
                                    </v-card-text>
                                </v-card>
                            </v-dialog>  
                </v-card-text>
                <v-snackbar
                    v-model="snackbar"
                    bottom
                    :color="colorm"
                    timeout = 8000
                    top
                    vertical
                >
                    {{ mensaje }}
                    <template >
                        <v-btn dark text @click="snackbar = false">
                            Close
                        </v-btn>
                    </template>
                </v-snackbar>
            </v-card>
            <v-dialog v-model="dialog6" max-width="850px">
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-card class="mx-auto">
                                    <v-list-item two-line>
                                    <v-list-item-content>                                                        
                                        <v-toolbar flat color="white">
                                            <v-toolbar-title>Contactos</v-toolbar-title>
                                            <v-divider
                                            class="mx-4"
                                            inset
                                            vertical
                                            ></v-divider>
                                            <v-spacer></v-spacer>                                                                    
                                        </v-toolbar>                                                              
                                        <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-card-text style="padding-top: 0; padding-bottom: 0;">                                                    
                                    <v-row align="center">
                                        <v-col md="6">
                                            <v-text-field v-model="editcontact.nombre" label="*Nombre contacto"></v-text-field>
                                        </v-col>
                                        <v-col sm="6" md="3">
                                            <v-text-field v-model="editcontact.puesto" label="Puesto"></v-text-field>
                                        </v-col>
                                        <v-col sm="6" md="3">
                                            <v-text-field v-model="editcontact.telefono" label="Teléfono"></v-text-field>
                                        </v-col>
                                        <v-col>
                                            <v-text-field v-model="editcontact.celular" label="Celular"></v-text-field>                                                            
                                        </v-col>
                                        <v-col >
                                            <v-text-field v-model="editcontact.correo" label="*Correo"></v-text-field>
                                        </v-col>                                                        
                                    </v-row>    
                                    <v-row>
                                        <v-col style="display: flex;flex-direction: row-reverse;margin-bottom: 10px;">
                                            <v-btn small color="primary" @click="agregarcontacto" dark>Agregar</v-btn>
                                        </v-col>
                                    </v-row>                                                 
                                    <v-row>
                                        <v-col  style="padding-bottom: 10px;">
                                            <v-data-table
                                            :headers="headersc"
                                            :items="contactos"
                                            sort-by="calories"
                                            class="elevation-1"
                                            >
                                            <template v-slot:[`item.activo`]="{ item }">  
                                                <div v-if="item.activo">
                                                    <span class="blue--text">Activo</span>                
                                                </div>
                                                <div v-else>
                                                    <span class="red--text">Inactivo</span>                
                                                </div>                  
                                            </template>
                                            <template v-slot:[`item.opciones`]="{ item }">
                                                        <v-icon
                                                        small
                                                        class="mr-2"
                                                        @click="editItemc(item)"
                                                        style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                        color="#3d5170"
                                                        >
                                                        edit
                                                        </v-icon>
                                                        <template v-if="item.activo">
                                                            <v-icon
                                                                small
                                                                class="mr-2"
                                                                @click="activarDesactivarMostrar(2,item)"
                                                                style="padding: 4px;border: 1px solid #e1e5eb;border-radius: 3px;"
                                                                color="#3d5170"
                                                                >
                                                                delete
                                                                </v-icon>                               
                                                        </template>                                                             
                                            </template>     
                                            </v-data-table>                                                            
                                        </v-col>
                                    </v-row>                                                    
                                </v-card-text>                                                
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-dialog>
            <v-dialog v-model="relacionprospectocliente" max-width="450px">
                <v-card>
                    <v-list-item two-line>
                        <v-list-item-content>                                                        
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Razón Social</v-toolbar-title>
                                <v-divider
                                class="mx-4"
                                inset
                                vertical
                                ></v-divider>
                                <v-spacer></v-spacer>                                                                    
                            </v-toolbar>                                                              
                            <v-list-item-subtitle>* Campos obligatorios</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-card-text>
                        <v-select :items="nrazonsocial" outlined dense label="Razon social"></v-select>
                        <!--<v-text-field label="Razón Social" outlined dense v-model="nrazonsocial"></v-text-field>-->
                        <v-btn  @click="enviarrelacion" color="primary">Enviar</v-btn>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogreporteCot" max-width="500px">
                <v-card>
                    <v-toolbar dark color="light-blue darken-3">                      
                        <v-toolbar-title class="titulo"><span class="headline">{{ numcotizacion }}</span></v-toolbar-title>
                      </v-toolbar>
                    <v-card-text ><!--Completar Reporte Cotizacion -->
                        <v-row style="padding-top: 16px;">
                            <v-col>
                                <v-select label="Actividad" v-model="idrechazocot" :items="RechazoCot"></v-select>
                            </v-col>                  
                        </v-row>                  
                        <v-row>
                            <v-col>
                                <v-textarea outlined  v-model="reportecot" label="Reporte"></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row style="border-top: 1px solid rgb(207, 216, 220);">
                            <v-btn text color="error" @click="dialogreporteCot = false">Cancelar</v-btn>
                            <v-btn text style="color:#1583da;" @click="GuardarComentarios()">Guardar</v-btn>                  
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-container>
</template>
<script>
import axios from 'axios'
import Vue from 'vue';
import PDFJSViewer from './PDFJSViewer'
import jsPDF from 'jspdf'
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';

  export default {
      name: 'app',
    components: {
        PDFJSViewer
    },
    data: () => ({
        numcotizacion:'',
        dialogreporteCot:false,
        RechazoCot:[],
        reportecot:'',
        idrechazocot:0,
        idactividad:0,
        relacionprospectocliente:false,
        nrazonsocial:[],
        incseguromercancia:'NO',
        contizacioningles:'ESPAÑOL',
        dialog6:false,
        editcontact:{
            idcontacto:'',
            nombre:'',
            puesto:'',
            telefono:'',
            celular:'',
            correo:'',            
        },
        contactos:[],
        headersc: [
            { text: 'OPCIONES', value: 'opciones', sortable: false },        
            { text: 'NOMBRE', value: 'nombre' },
            { text: 'PUESTO', value: 'puesto' },
            { text: 'TELÉFONO', value: 'telefono' },
            { text: 'CELULAR', value: 'celular' },
            { text: 'CORREO', value: 'correo', sortable: false },
            { text: 'ESTADO', value: 'activo' },
        ],
        loadigtable:false,
        InfoCot:false,
        snackbar:false,
        mensaje:'',
        colorm:'',
        dialodload:false,
        nowDate: new Date().toISOString().slice(0,10),
        dateval:null,
        vigenciatarifa:null,
        remk:'',
        MostrarTotal:false,
        dialograte:false,
        dialogne:false,
        pickup:'',
        enviar:false,
        ver:true,
        namefile: '', //change which pdf file loads
        path: 'SISTEMAOPTIMAGL/lib/pdfjs-2.5.207-dist/web/viewer.html',
        dialoview:false,
        idcustumer:'',
        RemarksCotizacion:[],
        Movimientotext:'',        
        menu2:'',
        costos:[],
        preciocostopor:[],
        monedas:[],
        activarc:false,
        searcho:'',
        productotext:'',
        origentext:'',
        cuerpo:'',
        destinotext:'',
        serviciotext:'',
        viatext:'',
        tttext:'',
        modalidadtext2:'',
        chargeconcepto:'',
        chargecostopor:'',
        chargecantidad:'',
        chargecostounitario:0,
        chargemoneda:'',
        chargeiva:0,
        subtotalusd:0,
        ivausd:0,
        totalusd:0,
        nsubtotalusd:0,
        nivausd:0,
        ntotalusd:0,
        activousd:false,
        subtotalmxn:0,
        ivamxn:0,
        totalmxn:0,
        nsubtotalmxn:0,
        nnsubtotalmxn:0,
        nivamxn:0,
        nnivamxn:0,
        nntotalmxn:0,
        activomxn:false,
        Observations:'',
        tarifapickup:[],
        tarifadeliver:[],
        selectedItempickup:[],
        selectedItemdelivery:[],
        remarkstextc:[],
        remarksc:'',
        remarklist: '',
        remarksview: false,
        contactosprospecto:[],
        editor: DecoupledEditor,
        namecot:'',
        fechaHoy:'',
        contactospresente:[],
        contactospresente:[],
        contactoscot:'',
        dialog: false,
        dialogDelete: false,
        headers: [
            {text:'Opciones', value: 'opciones', sortable: false,align:'center' },
            {text:'Ncotizacion',sortable: false,value: 'ncotizacion',align:'center'},
            {text:'Tariff #',value:'ntarif',align:'center'},
            {text:'Customer',sortable: false,value: 'ncustumer',align:'center'},
            {text:'Origen', value: 'origen',align:'center' },
            {text:'Destino', value: 'destino' ,align:'center'},
            {text:'Modalidad', value: 'modalidad' ,align:'center'},
            {text:'Movimiento', value: 'movimiento' ,align:'center'},
            {text:'Fecha envio', value: 'fechsend' ,align:'center'},            
            {text:'Asiganda', value: 'asignada' ,align:'center'},
        ],
        desserts: [],
        editedIndex: -1,
        editedItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
        },
        defaultItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
        },
        CotizacionesDatos:[],
        ncotizacionview:'',
        observaciones:[],
        editedIndexCosto:-1,
        ncotizacion:'',
        ncustumre:'',
        folio:'',
        basis:'',
        deliveryview:[],
        tarifas:[],
        tarifapickup:[],
        remarksview:'',
        idcotizacion:0,
        transbordo:'',
        search:'',
        lclviewremarks: false,
        remarkenabled:0,
        /*******************************/
        idejecutivo:0,
        idej:-1,
        ejecutivos:[],
        idscotizacion:0,
        Ntarifa:'',
        /*******************************/
        asignada:false,
        idcustumerogl:0,
        ReporteCotizacion:[],        
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
      computedDateFormatrecei () { 
            return this.formatDate(this.dateval)
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
        this.Listar();
        this.fechahoy();
        this.select();
        this.cargarremarks();
    },

    methods: {
        select(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var monedasArray = [];
            var preciocostoporArray = [];
            var usuariosarray = [];
            var datosclientes = [];
            var RechazoCot = [];

                axios.get('api/CatCotizaciones/Select',configuracion).then(function(response){                
                  RechazoCot=response.data;
                  RechazoCot.map(function(x){
                      me.RechazoCot.push({text:x.nombre,value:x.idcatcot});
                  });
                }).catch(function(error){
                    console.log(error);
                });

            axios.get('api/Datos/SelectCliente',configuracion).then(function(response){            
                datosclientes=response.data;
                datosclientes.map(function(x){
                    me.nrazonsocial.push({text:x.nombre,value:x.iddatos});
                });            
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/CostoporCotizaciones/Select',configuracion).then(function(response){
                preciocostoporArray = response.data
                preciocostoporArray.map(function(x){
                me.preciocostopor.push({text:x.nombre,value:x.idconcepto})
            });
            }).catch(function(error){
                console.log(error);
            });
            axios.get('api/Monedas/select',configuracion).then(function(response){
                monedasArray=response.data;
                monedasArray.map(function(x){
                    me.monedas.push({text:x.abreviatura,value:x.idmoneda});
                });            
            }).catch(function(error){
                console.log(error);
            }); 
            axios.get('api/Usuarios/SelectReportSC',configuracion).then(function(response){
                usuariosarray=response.data;
                usuariosarray.map(function(x){
                    me.ejecutivos.push({text:x.nombre,value:x.idusuario});
                });            
            }).catch(function(error){
                console.log(error);
            });
        },
        onReady( editor )  {
          // Insert the toolbar before the editable area.
              editor.ui.getEditableElement().parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
        },
        Listar(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.loadigtable = true;            
            me.idej = me.$store.state.usuario.idusuario;
            axios.get('api/Cotizaciones/Listarcotizacionusuarios/'+ me.$store.state.usuario.idusuario,configuracion).then(function(response){                
                me.CotizacionesDatos=response.data;
                me.loadigtable = false;
            }).catch(function(error){
                me.loadigtable = false;
                console.log(error);
            });
        },
        buscarejecutivo(){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.limpiarcotizacion();
            me.dialog = false;
            me.loadigtable = true;
            me.InfoCot = false;  
            me.CotizacionesDatos = [];

            axios.get('api/Cotizaciones/Listarcotizacionusuarios/'+ me.idejecutivo,configuracion).then(function(response){                
                me.CotizacionesDatos = response.data;
                me.loadigtable = false;
            }).catch(function(error){
                me.loadigtable = false;
                console.log(error);
            });
        },
        editItem (item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },
        Verificar(){
            /*if(this.idcustumerogl == 0){
                if (confirm("EL prospecto no se ha relacionado con un cliente, desea enviar el correo correspondiente")) {
                        this.relacionprospectocliente = true;
                    }
            }*/
        },
        AgregarComentarios(item){
            let me = this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header = {"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.loadigtable = true;            
            var ReporteCotizacion = [];
            me.reportecot = '';
            me.idrechazocot = 0;
            me.numcotizacion = 0;
            axios.get('api/Actividades/ReporteCot/'+ item.idcotizacion,configuracion).then(function(response){         
                   
                ReporteCotizacion = response.data; 
                me.idcotizacion = item.idcotizacion;
                me.numcotizacion =  item.ncotizacion;
                  
                    me.reportecot = ReporteCotizacion[0].reportecot;
                    me.idrechazocot = ReporteCotizacion[0].idreporte_cot;
                    me.idactividad = ReporteCotizacion[0].idactividad;
                    me.dialogreporteCot = true;
                    me.loadigtable = false;               
            }).catch(function(error){
                me.loadigtable = false;
                console.log(error);
            });
        },
        GuardarComentarios(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model = this;  
            model.dialodload = true;
            
            if(model.idrechazocot == 0 && model.reportecot == "" ){
                window.alert('Todos los campos son obligatorios')
            }else{
                axios.put('api/Actividades/ActualizarReporte',{
                    'idactividad': model.idactividad,
                    'idreporte_cot': model.idrechazocot,
                    'reportecot': model.reportecot,
                    'idcotizacion':model.idcotizacion,
                },configuracion).then(function(response){
                    model.dialogreporteCot = false;
                    model.dialodload = false;
                    model.Listar();
                    console.log('guardada')
                }).catch(function(error){
                    model.snackbar = true
                    model.dialodload = false;
                    model.mensaje = error;
                });
            }
            
        },
        enviarrelacion(){
            let model=this;  
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            model.dialodload = true;
            axios.post('api/Cotizaciones/Notificar',{
                'idusuario':model.$store.state.usuario.idusuario,
                'nrazon': model.nrazonsocial,
                'nprospecto': model.ncustumre,
            },configuracion).then(function(response){
               model.relacionprospectocliente = false;
               model.dialodload = false;
               model.snackbar = true
            model.mensaje = 'Correo envíado correctamente';
            }).catch(function(error){
                model.relacionprospectocliente = false;
                model.snackbar = true
                model.dialodload = false;
                model.mensaje = error;
            });
        },
        tarifasenviadas(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var ArrayCostos = [];
            var subtotal = 0;
            var iva = 0;
            var niva = 0;
            var total = 0;
            me.costos = [];
            me.subtotalusd = 0;
            me.ivausd = 0;
            me.totalusd = 0;
            me.nsubtotalusd = 0;
            me.nivausd = 0;
            me.ntotalusd = 0;
            me.subtotalmxn = 0;
            me.ivamxn = 0;
            me.totalmxn = 0;
            me.nsubtotalmxn = 0;
            me.nivamxn = 0;
            me.ntotalmxn = 0;
            axios.get('api/Tarifas_Cotizaciones/ListarTarifascotizacionusuarios/'+ id ,configuracion).then(function(response){                
                ArrayCostos=response.data;
                ArrayCostos.map(function(x){
                    subtotal = 0;
                    niva = 0;
                    total = 0;
                    if(x.idcostopor == 1 || x.idcostopor == 3 || x.idcostopor == 4){
                        subtotal = x.costounitario * x.cantidad;
                    }
                    if(x.idcostopor == 2 || x.idcostopor == 5){
                        subtotal = Number(x.costounitario);
                    }
                    if(x.iva == 1){
                        niva = subtotal * 0.16;
                        iva = 1;
                    }else{
                        iva = false;
                    }
                    total = (niva + subtotal);
                    if(total == NaN){
                        total = 0;
                    }
                    if(subtotal == NaN){
                        subtotal = 0;
                    }
                    if(x.moneda == 'USD'){
                        me.subtotalusd = me.subtotalusd + subtotal;
                        me.ivausd = me.ivausd + niva;
                        me.totalusd = me.totalusd + total;
                        me.nsubtotalusd = me.addCommas(parseFloat(me.subtotalusd).toFixed(2));
                        me.nivausd = me.addCommas(parseFloat(me.ivausd).toFixed(2))
                        me.ntotalusd = me.addCommas(parseFloat(me.totalusd).toFixed(2))
                        me.activousd = true;
                    }
                    if(x.moneda == 'MXN'){
                        me.subtotalmxn = me.subtotalmxn + subtotal;
                        me.ivamxn = me.ivamxn + niva;
                        me.totalmxn = me.totalmxn + total;
                        me.nsubtotalmxn = me.addCommas(parseFloat(me.subtotalmxn).toFixed(2));
                        me.nivamxn = me.addCommas(parseFloat(me.ivamxn).toFixed(2));
                        me.ntotalmxn = me.addCommas(parseFloat(me.totalmxn).toFixed(2));
                        me.activomxn = true;
                    }
                     me.costos.push({ 
                        idtarifascot:x.idtarifascot,
                        idcostopor:x.idcostopor,
                        concepto: x.concepto,
                        costopor: x.costopor,
                        cantidad: x.cantidad,
                        costounitario: x.costounitario,
                        ncostounitario:me.addCommas(x.costounitario),
                        idmoneda: x.idmoneda,
                        moneda: x.moneda,  
                        iva:x.iva,
                        ivas:x.iva,
                        niva:niva,
                        nniva:me.addCommas(parseFloat(niva).toFixed(2)),
                        subtotal:subtotal,
                        nsubtotal:me.addCommas(parseFloat(subtotal).toFixed(2)),
                        total:total,
                        ntotal:me.addCommas(parseFloat(total).toFixed(2)),
                        activo:true
                    });
                });
            }).catch(function(error){
                console.log(error);
            });
        },
        deleteItem (item) {
            this.editedIndex = this.desserts.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },
        deleteItemConfirm () {
            this.desserts.splice(this.editedIndex, 1)
            this.closeDelete()
        },
        close () {
            this.dialog = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },
        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.editedIndex = -1
            })
        },
        save () {
            if (this.editedIndex > -1) {
            Object.assign(this.desserts[this.editedIndex], this.editedItem)
            } else {
            this.desserts.push(this.editedItem)
            }
            this.close()
        },
        fechahoy(){
            const date = new Date()
            const dateTimeFormat = new Intl.DateTimeFormat('Mx', { year: 'numeric', month: 'long', day: '2-digit' }) 
            const [{ value: month },,{ value: day },,{ value: year }] = dateTimeFormat .formatToParts(date ) 
            this.fechaHoy = `${month} de ${day} del ${year }`;
        },
        agregarcosto(){
            var niva = 0;
            var subtotal = 0;
            var total = 0;
            if(this.chargecostopor.value == undefined){
                if(this.chargecostopor == 1 || this.chargecostopor == 3 || this.chargecostopor == 4){
                    subtotal = this.chargecostounitario * this.chargecantidad;
                }
                if(this.chargecostopor == 2 || this.chargecostopor == 5){
                    subtotal = Number(this.chargecostounitario);
                }
            }else{
                if(this.chargecostopor.value == 1 || this.chargecostopor.value == 3 || this.chargecostopor.value == 4){ 
                    subtotal = this.chargecostounitario * this.chargecantidad;
                }
                if(this.chargecostopor.value == 2 || this.chargecostopor.value == 5){
                    subtotal = Number(this.chargecostounitario);
                    this.chargecantidad = 1;
                }
            }            
            var iva = false;
            if(this.chargeiva == 1){
                niva = subtotal * 0.16;
                iva = 1;
            }else{
                iva = false;
            }
            total = (niva + subtotal);
            if(this.chargeconcepto != ''){
                if(this.editedIndexCosto > -1){
                    var chargecostopor = '';
                    var idcostopor = '';
                    var moneda = '';
                    var idmoneda = '';
                    if(this.chargecostopor.text == undefined){
                        chargecostopor = this.costos[this.editedIndexCosto].costopor;    
                        idcostopor =this.costos[this.editedIndexCosto].idcostopor;    
                    }else{
                        chargecostopor =this.chargecostopor.text;
                        idcostopor = this.chargecostopor.value;
                    }
                    if(this.chargemoneda.text == undefined){
                        moneda = this.costos[this.editedIndexCosto].moneda;
                        idmoneda = this.costos[this.editedIndexCosto].idmoneda;
                    }else{
                        moneda = this.chargemoneda.text;
                        idmoneda = this.chargemoneda.value;
                    }
                    if(this.chargemoneda == 1 || this.chargemoneda.text == 'USD'){
                        this.subtotalusd = this.subtotalusd + subtotal;
                        this.ivausd = this.ivausd + niva;
                        this.totalusd = this.totalusd + total;
                        this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                        this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                        this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                        this.activousd = true;
                    }
                    if(this.chargemoneda == 2 || this.chargemoneda.text == 'MXN'){
                        this.subtotalmxn = this.subtotalmxn + subtotal;
                        this.ivamxn = this.ivamxn + niva;
                        this.totalmxn = this.totalmxn + total;
                        this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                        this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                        this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                        this.activomxn = true;
                    }
                    Object.assign(this.costos[this.editedIndexCosto],{
                        idtarifascot:this.costos[this.editedIndexCosto].idtarifascot,
                        idcostopor:idcostopor,
                        concepto: this.chargeconcepto,
                        costopor:chargecostopor,
                        cantidad:this.chargecantidad,
                        costounitario:Number(this.chargecostounitario),
                        ncostounitario:this.addCommas(this.chargecostounitario),
                        idmoneda:idmoneda,
                        moneda:moneda,  
                        iva:iva,
                        ivas:this.chargeiva,
                        niva:niva,
                        nniva:this.addCommas(parseFloat(niva).toFixed(2)),
                        subtotal:subtotal,
                        nsubtotal:this.addCommas(parseFloat(subtotal).toFixed(2)),
                        total:total,
                        ntotal:this.addCommas(parseFloat(total).toFixed(2)),
                        activo:true
                    });
                    this.editedIndexCosto = -1;
                    this.limpiarcostos(); 
                }else{
                    if(this.chargemoneda.text == 'USD'){
                        this.subtotalusd = this.subtotalusd + subtotal;
                        this.ivausd = this.ivausd + niva;
                        this.totalusd = this.totalusd + total;
                        this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                        this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                        this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                        this.activousd = true;
                    }
                    if(this.chargemoneda.text == 'MXN'){
                        this.subtotalmxn = this.subtotalmxn + subtotal;
                        this.ivamxn = this.ivamxn + niva;
                        this.totalmxn = this.totalmxn + total;
                        this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                        this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                        this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                        this.activomxn = true;
                    }
                    if(this.chargecostopor.value != undefined){
                        this.costos.push({ 
                            idtarifascot:0,
                            idcostopor:this.chargecostopor.value,
                            concepto: this.chargeconcepto,
                            costopor:this.chargecostopor.text,
                            cantidad:this.chargecantidad,
                            costounitario:this.chargecostounitario,
                            ncostounitario:this.addCommas(this.chargecostounitario),
                            idmoneda:this.chargemoneda.value,
                            moneda:this.chargemoneda.text,  
                            iva:iva,
                            ivas:this.chargeiva,
                            niva:niva,
                            nniva:this.addCommas(parseFloat(niva).toFixed(2)),
                            subtotal:subtotal,
                            nsubtotal:this.addCommas(parseFloat(subtotal).toFixed(2)),
                            total:total,
                            ntotal:this.addCommas(parseFloat(total).toFixed(2)),
                            activo:true
                        });
                        this.limpiarcostos();
                    } else{
                        window.alert('Selecciona una opcion de costo');        
                    }
                }
            }else{
                window.alert('Facor de agregar un concepto');
            }
        },
        activarcantidad(){
            if(this.chargecostopor.value == 1){
                this.activarc= false;
            }else{
                this.activarc= true;
            }
        },
        limpiarcostos(){
            this.chargeconcepto = '';
            this.chargecostopor = '';
            this.chargecantidad = '';
            this.chargecostounitario = 0;
            this.chargemoneda = '';
            this.chargeiva = '';
            this.editedIndexCosto = -1;
        },
        addCommas(nStr) {
            nStr += '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        },
        cargarremarks(){
            this.RemarksCotizacion = [];
            var remarkfcl = [];
            if(this.contizacioningles == 'INGLES'){
                this.disabledIva = true;
                this.remarkenabled = 6;
                this.bodyCot = 'Our quotation for the services requested is as follows';
                
                remarkfcl.push(
                    {text:'No maneuvers on Airport/Port included, these must be paid by the customs agent.',value:1},
                    {text:'All inlands are quoted in tandem ( 2 containers per truck)',value:2},
                    {text:'No customs maneuvers included.',value:3},
                    {text:'No customs storage included.',value:4},
                    {text:'No inspections included.',value:5},
                    //{text:'',value:6},
                    {text:'No custody included.',value:7},
                    {text:'No unloading/loading maneuvers included',value:8},
                    {text:'Free unloading time',value:9},
                    {text:'Rate based on the information provided.',value:10},
                    //{text:'Otro.',value:16}
                );
            }else{
                this.remarkenabled = 15;
                this.disabledIva = false;
                this.bodyCot = 'Me permito enviarle nuestra cotización';
                remarkfcl.push(
                    {text:'Los costos no incluyen maniobras.',value:1},
                    {text:'horas libres de carga.',value:2},
                    {text:'horas libres de descarga.',value:3},
                    {text:'días de crédito.',value:4},
                    {text:'Sujeto a disponibilidad de espacio y equipo.',value:5},
                    {text:'Incluye Carta Garantía.',value:6},
                    {text:'Los tiempos de tránsito son estimados. ',value:7},
                    {text:'Terrestre dentro de BL en servicio Full.',value:8},
                    {text:'Terrestre dentro de BL en servicio Sencillo.',value:9},
                    {text:'días libres de demoras en origen.',value:10},
                    {text:'días libres de demoras en destino.',value:11},
                    {text:'Costos para carga peligrosa.',value:12},
                    {text:'Costos para carga No peligrosa.',value:13},
                    {text:'Incluye gastos locales en origen.',value:14},
                    //{text:'',value:15},
                    //{text:'Otro.',value:16}
                );
            }
            this.RemarksCotizacion = remarkfcl;
        },
        agregarremarks(){
                var rtext = '';
                var idremarktext = '';
                var rvalue = 0;

                if(this.editedIndexRemarks > -1){
                    if(this.remarklist.text == undefined){
                        if(this.remarkstextc[this.editedIndexRemarks].idremark == 16){
                            rtext = this.remarksc;
                        }else{
                            rtext = this.remarksc + " " + this.remarkstextc[this.editedIndexRemarks].idremarktext;
                        }
                        idremarktext = this.remarkstextc[this.editedIndexRemarks].idremarktext
                        rvalue = this.remarkstextc[this.editedIndexRemarks].idremark;
                    }else{
                        if(this.remarklist.value == 16){
                            rtext = this.remarksc;
                        }else{
                            rtext = this.remarksc + " " + this.remarklist.text;
                        }
                        idremarktext = this.remarklist.text;
                        rvalue = this.remarklist.value;
                    } 
                    Object.assign(this.remarkstextc[this.editedIndexRemarks],{
                        idobs:this.remarkstextc[this.editedIndexRemarks].idobs,
                        text: rtext,
                        idremarktext:idremarktext,
                        observacion:this.remarksc,
                        idremark:rvalue,
                        activo:true
                    });
                    this.editedIndexRemarks = -1;
                }else{
                    if(this.remarksc != '' || this.remarklist.text != undefined){
                        if(this.remarklist.text != undefined){
                            rtext =  this.remarklist.text;
                            rvalue = this.remarklist.value;
                        }
                        this.remarkstextc.push({
                            idobs:0,
                            text: this.remarksc + " " + rtext,
                            idremarktext:rtext,
                            observacion: this.remarksc,
                            idremark:rvalue,
                            activo:true
                        });
                        
                    }else{
                        window.alert('Agrgar un Comentario')
                    }
                }
            this.remarksc = '';
            this.remarklist = '';
            this.remarksview = true;
        },
        mostrarfree(){
            if(this.remarklist.value == 10){
                this.remarksc = this.tarifas[this.selectedItem].freedaysorigin;
            }else if(this.remarklist.value == 11){
                this.remarksc = this.tarifas[this.selectedItem].freedasydestination;
            }else{
                this.remarksc = '';
            }   
        },
        montrarneg(item){
            this.ncotizacionview = item.ncotizacion;
            this.dialogne = true;
        },
        async editItemCot(item){
            this.nsubtotalusd = 0;
            this.nivausd = 0;
            this.ntotalusd = 0;
            this.nsubtotalmxn = 0;
            this.nivamxn = 0;
            this.ntotalmxn = 0;
            this.limpiarcotizacion();
            this.limpiarcostos();
            this.productotext = item.producto;
            this.origentext = item.origen;
            this.cuerpo = item.body;
            this.destinotext = item.destino;
            this.serviciotext = item.servicio;
            this.viatext = item.via;
            this.tttext = item.tt;
            this.Movimientotext = item.movimiento;
            this.modalidadtext2 = item.modalidad;
            this.dateval = item.vigencia;
            this.idcustumer = item.idcustumer;
            this.ncotizacion = item.ncotizacion;
            this.ncustumre = item.ncustumer;
            this.folio = item.folio;
            this.basis = item.basis;
            this.idcotizacion = item.idcotizacion;
            this.transbordo = item.transbordo;
            this.lclviewremarks= false;
            this.idscotizacion = item.idscotizacion;
            this.Ntarifa = item.ntarif;
            this.asignada = item.asignada;
            this.idcustumerogl = item.idcustumerogl;

            await this.listarContacto(item.idcustumer);
            await this.listarconceptos(item.idcotizacion);
            await this.tarifasenviadas(item.idcotizacion);
            await this.listartarifag(item.idcotizacion);
            this.InfoCot = true;     
        },
        limpiarcotizacion(){
            this.productotext = '';
            this.origentext = '';
            this.cuerpo = '';
            this.destinotext = '';
            this.serviciotext = '';
            this.viatext = '';
            this.tttext = '';
            this.Movimientotext = '';
            this.modalidadtext2 = '';
            this.dateval = '';
            this.idcustumer = '';
            this.transbordo = '';
            this.idcustumer = 0;
            this.ncotizacion = '';
            this.ncustumre = '';
            this.folio = '';
            this.basis = '';
            this.idcotizacion = '';
            this.contactoscp = '';
            this.contactoscot = '';
            this.cargarremarks()
        },
        async listarconceptos(idcotizacion){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var ArrayObservaciones = [];
            var RemarksCotizacion = '';
            me.remarkstextc = [];
            axios.get('api/ObservacionesCotizacions/Listarcotizacionusuarios/'+ idcotizacion ,configuracion).then(await function(response){                
                ArrayObservaciones=response.data;
                ArrayObservaciones.map(function(x){
                    if(x.idremark > 0 && x.idremark != 100 ){
                        RemarksCotizacion = me.RemarksCotizacion[x.idremark-1].text;
                    }else{
                        RemarksCotizacion = '';
                    }
                    var comentario='';
                    if(x.observacion == ''){
                        comentario = RemarksCotizacion;
                    }
                    else{
                        comentario = x.observacion + " " + RemarksCotizacion;
                    }
                    var activor;
                    if(x.idremark == me.remarkenabled){
                        activor = false
                    }else{
                        activor = true
                    }
                    me.remarkstextc.push({
                        idobs:x.idobs,
                        text: comentario,
                        idremarktext: RemarksCotizacion,
                        observacion: x.observacion,
                        idremark: x.idremark,
                        activo:activor
                    });
                });
                if(me.remarkstextc.length > 0){
                    me.remarksview = true;
                }else{
                    me.remarksview = false;
                }
            }).catch(function(error){
                console.log(error);
            });
        },
        editRemarks(item){
            this.editedIndexRemarks = this.remarkstextc.indexOf(item)
            this.remarklist = item.idremark;
            this.remarksc = item.observacion;
        },
        deleteRemarks(item){
            const index = this.remarkstextc.indexOf(item)
            var resp = confirm('Are you sure you want to delete this remark?');
            if(resp == true){
                this.remarkstextc[index].activo = false;
            }
        },
        listarContacto(id){
            var ContactosP = [];
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.contactosprospecto = [];
            me.contactospresente = [];
            axios.get('api/Contactos/ListarContacto/' + id,configuracion).then(function(response){            
            //axios.get('api/Contactos/Listar/',configuracion).then(function(response){            
            ContactosP=response.data;
            ContactosP.map(function(x){
              me.contactosprospecto.push({text:x.nombre+" <" + x.correo+ ">",value:x.idcontacto,correo:x.correo})
              me.contactospresente.push({text:x.nombre,value:x.idcontacto})
            });
            }).catch(function(error){
                console.log(error);
            });
        },
        crearCotizacion(){
            this.GuardarCotizacion();
            this.ver = true;
            this.enviar = false;
            this.cpasunto = '';
            this.editorcp = '';
            this.namecot = '';
            this.contactoscp = '';
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            if(model.contactoscot != ''){
                if(model.lclviewremarks == false){
                    if(model.basis == 2){
                        if(model.contizacioningles == 'INGLES'){
                            model.remarkstextc.push({
                                text: "In case of any extraordinary costs at POL/POD due storages, terminal handling costs, additional expenses caused by roll overs, delay of vessel’ departure (ETD), ommision on behalf of steamship line and/or any other expenses not previously considered,  shall be fully paid by shipper and/or consignee.",
                                idremarktext:100,
                                observacion: "",
                                idremark:100,
                                activo:true
                            });
                        }else{
                            model.remarkstextc.push({
                                text: "En caso de existir costos extraordinarios ya sea en puerto de carga y/o descarga, por concepto de almacenajes, costos de terminal portuaria, gastos adicionales derivados de un roll over, atraso en el zarpe del buque, omisión de puerto por parte de la línea naviera o cualquier otro no contemplado, éstos deberán ser cubiertos en su totalidad por el embarcador y/o consignatario.",
                                idremarktext:100,
                                observacion: "",
                                idremark:100,
                                activo:true
                            });
                        }
                    }
                }

                var incseguro
                if(model.incseguromercancia == 'SI'){
                    incseguro= true;
                }else{
                    incseguro= false;
                }
                var ingles = false;
                if(model.contizacioningles == 'INGLES'){
                    ingles= true;
                }else{
                    ingles= false;
                }


                axios.post('api/Scotizaciones/Cotizacion',{
                    'basis':model.basis,
                    'idcustumer':model.idcustumer,
                    'ncotizacion':model.ncotizacion,
                    'folio':model.folio,
                    'prospecto':model.ncustumre,
                    'nusuario': model.$store.state.usuario.nombre + " " + model.$store.state.usuario.apellido,
                    'body':model.cuerpo,
                    'modalidad':model.modalidadtext2,
                    'movimiento':model.Movimientotext,
                    'producto':model.productotext,
                    'origen':model.origentext,
                    'transbordo':model.transbordo,
                    'via':model.viatext,
                    'destino':model.destinotext,
                    'servicio':model.serviciotext,
                    'tt':model.tttext,
                    'Comentarios':model.remarkstextc,
                    'tarifa':model.costos,
                    'mostrartotal':model.MostrarTotal,
                    'ncontacto':model.contactoscot,
                    'valid':model.dateval,
                    'vigencia':model.dateval,
                    'nsubtotalusd':model.nsubtotalusd,
                    'nivausd':model.nivausd,
                    'ntotalusd':model.ntotalusd,
                    'activousd':model.activousd,
                    'nsubtotalmxn':model.nsubtotalmxn,
                    'nivamxn':model.nivamxn,
                    'ntotalmxn':model.ntotalmxn,
                    'activomxn':model.activomxn,
                    'rol':model.$store.state.usuario.rol,
                    'incseguro':incseguro,
                    'ingles':ingles
                },configuracion).then(function(response){
                    model.namecot = model.idcustumer + "/" +model.ncotizacion + "/" + response.data
                    model.colorm ='info';
                    model.nombrec = response.data;
                    model.dialodload = false;
                    model.dialoview = true;
                }).catch(function(error){
                    model.colorm ='error'
                    model.snackbar = true;
                    model.mensaje = error;
                    model.dialodload = false;
                });
            }else{
                model.dialodload = false;
                window.alert('Seleccionar un Contacto')                
            }
        },
        editItemcostos(item){
            if(item.idmoneda == 2){
                this.subtotalmxn = Number(this.subtotalmxn) - Number(item.subtotal);
                this.ivamxn = Number(this.ivamxn) - Number(item.niva);
                this.totalmxn = Number(this.totalmxn) - Number(item.total);
                this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                if(this.totalmxn == 0){
                    this.activomxn = false;
                }
            }
            if(item.idmoneda == 1){
                this.subtotalusd = Number(this.subtotalusd) - Number(item.subtotal);
                this.ivausd = Number(this.ivausd) - Number(item.niva);
                this.totalusd = Number(this.totalusd) - Number(item.total);
                this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                if(this.totalusd == 0){
                    this.activousd = false;
                }
            
            }
            this.editedIndexCosto = this.costos.indexOf(item)
            this.chargeconcepto = item.concepto;
            this.chargecostopor = item.idcostopor;
            this.chargecantidad = item.cantidad;
            this.chargecostounitario = item.costounitario;
            this.chargemoneda = item.idmoneda;
            this.chargeiva = item.iva;
        },
        enviarcorreocp(){
            let loader = Vue.$loading.show({color: '#189bec',loader: 'spinner'});
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;
            axios.post('api/Scotizaciones/EnviarMailCotizacion',{
              asunto:model.cpasunto,
              idusuario:Number(model.$store.state.usuario.idusuario),
              contenido:model.editorcp,
              url:model.namecot,
              nconsecutivo:model.folio,
              idcustumer:model.idcustumer,
              idscotizacion:model.idcotizacion,
              contactoscc:model.contactoscp,
            },configuracion).then(function(response){
                  loader.hide()
                  model.colorm ='info';
                  model.snackbar = true 
                  model.mensaje = 'Correo enviado correctamente'
                  model.cartap = false;
                  model.dialoview = false;
                  model.InfoCot = false;
                  model.limpiarcotizacion();
                  model.limpiarcostos();
            }).catch(function(error){
                loader.hide()                                                
                model.colorm ='error'
                model.snackbar = true
                model.mensaje = error
            });
        },
        listartarifag(id){
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            me.tarifas = [];
            me.tarifadeliver = [];
            me.tarifapickup = [];
            me.principalview = [];
            var arrayt = [];
            var consulta;
            var ni = 0;
            var primero = false;
            consulta = 'api/TarifasSeleccionadas/ListarContainersUsers/';
                axios.get(consulta + id ,configuracion).then(function(response){                
                    arrayt= response.data;
                    setTimeout(function(){
                        arrayt.map(function(x){
                            ni = ni + 1;
                            me.dateval = x.fechavigencia;
                            var f1 = new Date(x.fechavigencia)
                            var f2 = new Date(me.dateval)
                            if(primero == false){
                                me.dateval = x.fechavigencia;
                                me.vigenciatarifa = x.fechavigencia;
                                primero = true; 
                            }
                            if(f1 < f2){
                                me.dateval = x.fechavigencia;
                                me.vigenciatarifa = x.fechavigencia;
                            }
                            if(x.descripcion == 'Delivery'){
                                me.deliveryview = true;
                                me.tarifadeliver.push({
                                    vigencia:x.vigencia,
                                    tipe:x.tipe,
                                    tarifaAd:x.tarifaAd,
                                    rate:x.rate,
                                    observaciones:x.observaciones,
                                    nrate:x.nrate,
                                    nidprovider:x.nidprovider,
                                    idscotizacion:x.idscotizacion,
                                    idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate,
                                    idcontainer:x.idcontainer,
                                    idagent:x.idagent,
                                    idsize:x.idsize,
                                    size:x.size,
                                    idtype:x.idtype,
                                    type:x.type,
                                    general:x.general,
                                    freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination,
                                    fechavigencia:x.fechavigencia,
                                    exclusivo:x.exclusivo,
                                    ex:x.ex,
                                    descripcion:x.descripcion,
                                    rol:x.rol,
                                    quantity:x.quantity,
                                    activo:x.activo
                                });
                            }
                            if(x.descripcion == 'Inland Freight' || x.descripcion == 'Ocean Freight' || x.descripcion == 'Air Freight'){
                                me.principalview = true;
                                me.tarifas.push({
                                    vigencia:x.vigencia,
                                    tipe:x.tipe,
                                    tarifaAd:x.tarifaAd,
                                    rate:x.rate,
                                    observaciones:x.observaciones,
                                    nrate:x.nrate,
                                    nidprovider:x.nidprovider,
                                    idscotizacion:x.idscotizacion,
                                    idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate,
                                    idcontainer:x.idcontainer,
                                    idagent:x.idagent,
                                    idsize:x.idsize,
                                    size:x.size,
                                    idtype:x.idtype,
                                    type:x.type,
                                    general:x.general,
                                    freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination,
                                    fechavigencia:x.fechavigencia,
                                    exclusivo:x.exclusivo,
                                    ex:x.ex,
                                    descripcion:x.descripcion,
                                    rol:x.rol,
                                    quantity:x.quantity,
                                    activo:x.activo
                                });
                            }
                            if(x.descripcion == 'Pickup'){
                                me.recoleccionview = true;
                                me.tarifapickup.push({
                                    vigencia:x.vigencia,
                                    tipe:x.tipe,
                                    tarifaAd:x.tarifaAd,
                                    rate:x.rate,
                                    observaciones:x.observaciones,
                                    nrate:x.nrate,
                                    nidprovider:x.nidprovider,
                                    idscotizacion:x.idscotizacion,
                                    idprovider:x.idprovider,
                                    idlistarifarate:x.idlistarifarate,
                                    idcontainer:x.idcontainer,
                                    idagent:x.idagent,
                                    idsize:x.idsize,
                                    size:x.size,
                                    idtype:x.idtype,
                                    type:x.type,
                                    general:x.general,
                                    freedaysorigin:x.freedaysorigin,
                                    freedasydestination:x.freedasydestination,
                                    fechavigencia:x.fechavigencia,
                                    exclusivo:x.exclusivo,
                                    ex:x.ex,
                                    descripcion:x.descripcion,
                                    rol:x.rol,
                                    quantity:x.quantity,
                                    activo:x.activo
                                });
                            }
                            if(arrayt.length == ni){
                                me.dialodload = false;
                                me.dialog3 = true;
                            }
                        });
                    },0 | Math.random() * 2500);
                }).catch(function(error){
                    console.log(error);
                });
        },
        formatDate(date){
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        GuardarCotizacion(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;  
            model.dialodload = true;
            axios.put('api/Cotizaciones/Actualizar',{
                'idscotizacion':model.idcotizacion,
                'idcustumer':model.idcustumer,
                'body':model.cuerpo,
                'modalidad':model.modalidadtext2,
                'movimiento':model.Movimientotext,
                'producto':model.productotext,
                'origen':model.origentext,
                'destino':model.destinotext,
                'servicio':model.serviciotext,
                'tt':model.tttext,
                'vigencia':model.dateval,//model.dateval,
                'idprincipalrate':1,
                'idpickuprate':1,
                'iddeliveryrate':1,
                'ccotizaciones':model.costos,
                'observaciones':model.remarkstextc,
                'asignada':model.asignada,
            },configuracion).then(function(response){
                model.listarconceptos(model.idcotizacion);
                model.tarifasenviadas(model.idcotizacion);    
                model.dialodload = false;
                model.Listar();
            }).catch(function(error){
                model.snackbar = true
                model.dialodload = false;
                model.mensaje = error;
            });
        },
        deleteICosto(item) {
            const index = this.costos.indexOf(item)
            var resp = confirm('Are you sure you want to delete this rate?');
            if(resp == true){
                if(item.idmoneda == 2){
                    this.subtotalmxn = Number(this.subtotalmxn) - Number(item.subtotal);
                    this.ivamxn = Number(this.ivamxn) - Number(item.niva);
                    this.totalmxn = Number(this.totalmxn) - Number(item.total);
                    this.nsubtotalmxn = this.addCommas(parseFloat(this.subtotalmxn).toFixed(2));
                    this.nivamxn = this.addCommas(parseFloat(this.ivamxn).toFixed(2));
                    this.ntotalmxn = this.addCommas(parseFloat(this.totalmxn).toFixed(2));
                    if(this.totalmxn == 0){
                        this.activomxn = false;
                    }
                }
                if(item.idmoneda == 1){
                    this.subtotalusd = Number(this.subtotalusd) - Number(item.subtotal);
                    this.ivausd = Number(this.ivausd) - Number(item.niva);
                    this.totalusd = Number(this.totalusd) - Number(item.total);
                    this.nsubtotalusd = this.addCommas(parseFloat(this.subtotalusd).toFixed(2));
                    this.nivausd = this.addCommas(parseFloat(this.ivausd).toFixed(2))
                    this.ntotalusd = this.addCommas(parseFloat(this.totalusd).toFixed(2))
                    if(this.totalusd == 0){
                        this.activousd = false;
                    }
                }
                this.costos[index].activo = false;
            }
        },
        agregarcontacto(){
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            let model=this;

            if(model.editcontact.nombre === '' || model.editcontact.correo === ''){        
                model.adModalcontact = true;
            }else
            {
                if (model.editedIndex > -1) {
                    Object.assign(model.contactos[model.editedIndex], model.editcontact)    
                    axios.put('api/Contactos/Actualizar',{
                        'idcontacto': model.editcontact.idcontacto,                            
                        'nombre': model.editcontact.nombre,
                        'puesto' : model.editcontact.puesto,                    
                        'telefono' : model.editcontact.telefono,
                        'celular' : model.editcontact.celular,
                        'correo' : model.editcontact.correo,
                        'idpropietario' : model.iddatos
                    },configuracion).then(function(response){                                                                       
                        model.editedIndex = -1;                            
                        model.limpiarC();
                        model.snackbar = true;
                        model.dialog6 = false; 
                        model.mensaje = 'Contacto Actualizado';
                        model.listarContacto(model.idcustumer);                                                    
                    }).catch(function(error){
                        console.log(error);
                    });  

                } else {  
                    model.contactos.push({
                        nombre:model.editcontact.nombre,
                        puesto:model.editcontact.puesto,
                        telefono:model.editcontact.telefono,
                        celular:model.editcontact.celular,
                        correo:model.editcontact.correo,
                        activo:1
                    })                      
                        axios.post('api/Contactos/Crear',{
                        'nombre': model.editcontact.nombre,
                        'puesto' : model.editcontact.puesto,                    
                        'telefono' : model.editcontact.telefono,
                        'celular' : model.editcontact.celular,
                        'correo' : model.editcontact.correo,
                        'propietario' : 'Pros',
                        'idpropietario' : model.idcustumer
                    },configuracion).then(function(response){                                  
                        model.limpiarC();
                        model.snackbar = true;
                        model.dialog6 = false; 
                        model.mensaje = 'Contacto guardado  ' 
                        model.listarContacto(model.idcustumer);
                    }).catch(function(error){                                                
                        console.log(error); 
                    });          
                }
                model.limpiarC();
            }
        },
        limpiarC(){
            this.editcontact.nombre = "";
            this.editcontact.puesto = "";
            this.editcontact.telefono= "";
            this.editcontact.celular = "";
            this.editcontact.correo = "";        
            this.editedIndex = -1;
        },
        viewContacto(){
            this.dialog6 = true;
        },
    },
  }
</script>